import { NxGridModule } from "@allianz/ng-aquila/grid";
import {
  IPaginationTexts,
  NX_PAGINATION_TEXTS,
} from "@allianz/ng-aquila/pagination";
import { NxPaginationModule } from "@allianz/ng-aquila/pagination";
import { CommonModule } from "@angular/common";
import {
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { LayoutBreakPointsService } from "src/app/shared/services/layout-break-points.service";

let myPaginationTexts: IPaginationTexts = {
  previous: "BACK",
  next: "NEXT",
  ofLabel: "of",
  ariaLabel: "",
};
@Component({
  selector: "app-search-form-pagination",
  templateUrl: "./search-form-pagination.component.html",
  styleUrls: ["./search-form-pagination.component.scss"],
  providers: [{ provide: NX_PAGINATION_TEXTS, useValue: myPaginationTexts }],
  standalone: true,
  imports: [CommonModule, NxGridModule, NxPaginationModule],
})
export class SearchFormPaginationComponent implements OnInit, OnChanges {
  private readonly destroyRef = inject(DestroyRef);

  @Input() public data: any[] = [];
  @Input() public searchInput: any;
  @Output() public perPage: EventEmitter<number> = new EventEmitter<number>();
  @Output() public curPage: EventEmitter<number> = new EventEmitter<number>();

  protected count: number = 0;
  protected curPageSelected: number = 1;
  protected perPageSelected: number = 10;

  protected desktopScreen: boolean = false;

  constructor(
    private readonly layoutBreakPointService: LayoutBreakPointsService,
  ) {}

  ngOnInit(): void {
    this.getDataLength();
    this.layoutBreakPointService
      .subscribeLayoutChanges()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.desktopScreen = this.layoutBreakPointService.renderDesktop();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes.data?.currentValue) {
        this.count = (changes.data.currentValue as any[]).length;
      }

      if (changes.searchInput) {
        this.curPageSelected = 1;
      }
    }
  }

  protected getDataLength(): void {
    this.count = this.data?.length ?? 0;
  }

  protected prevPage(): void {
    this.curPageSelected--;
    this.curPage.emit(this.curPageSelected);
  }

  protected nextPage(): void {
    this.curPageSelected++;
    this.curPage.emit(this.curPageSelected);
  }

  protected goToPage(n: number): void {
    this.curPageSelected = n;
    this.curPage.emit(n);
  }
}
